// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/diagram.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { DiagramResponse, GetContextDiagramRequest, GetDataPipelineDiagramRequest, GetDiagramMetricsRequest, GetDiagramMetricsResponse, GetEntityFsmDiagramRequest, GetEventFlowDiagramRequest, GetPluginMapRequest, GetSystemDiagramRequest, GetWorkflowDiagramRequest } from "./diagram_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.DiagramService
 */
export const DiagramService = {
  typeName: "omnios.v1.DiagramService",
  methods: {
    /**
     * Full system overview: all contexts, entities, workflows, plugins, event flows.
     *
     * @generated from rpc omnios.v1.DiagramService.GetSystemDiagram
     */
    getSystemDiagram: {
      name: "GetSystemDiagram",
      I: GetSystemDiagramRequest,
      O: DiagramResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Single bounded context detail: entities, projectors, services, workflows.
     *
     * @generated from rpc omnios.v1.DiagramService.GetContextDiagram
     */
    getContextDiagram: {
      name: "GetContextDiagram",
      I: GetContextDiagramRequest,
      O: DiagramResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Workflow step diagram: steps, branches, signals, compensations.
     *
     * @generated from rpc omnios.v1.DiagramService.GetWorkflowDiagram
     */
    getWorkflowDiagram: {
      name: "GetWorkflowDiagram",
      I: GetWorkflowDiagramRequest,
      O: DiagramResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Entity FSM diagram: states and transitions.
     *
     * @generated from rpc omnios.v1.DiagramService.GetEntityFsmDiagram
     */
    getEntityFsmDiagram: {
      name: "GetEntityFsmDiagram",
      I: GetEntityFsmDiagramRequest,
      O: DiagramResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Plugin extension point map for this workspace.
     *
     * @generated from rpc omnios.v1.DiagramService.GetPluginMap
     */
    getPluginMap: {
      name: "GetPluginMap",
      I: GetPluginMapRequest,
      O: DiagramResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Event flow diagram: entity → outbox → NATS → subscribers.
     *
     * @generated from rpc omnios.v1.DiagramService.GetEventFlowDiagram
     */
    getEventFlowDiagram: {
      name: "GetEventFlowDiagram",
      I: GetEventFlowDiagramRequest,
      O: DiagramResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Data pipeline diagram: entity events → KV/ClickHouse sinks.
     *
     * @generated from rpc omnios.v1.DiagramService.GetDataPipelineDiagram
     */
    getDataPipelineDiagram: {
      name: "GetDataPipelineDiagram",
      I: GetDataPipelineDiagramRequest,
      O: DiagramResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Real-time metrics overlay for diagram nodes (polled periodically by frontend).
     *
     * @generated from rpc omnios.v1.DiagramService.GetDiagramMetrics
     */
    getDiagramMetrics: {
      name: "GetDiagramMetrics",
      I: GetDiagramMetricsRequest,
      O: GetDiagramMetricsResponse,
      kind: MethodKind.Unary,
    },
  }
};

